export const algorithm = 'aes-256-cbc';
export const encoding = 'hex';
